import { FC, MouseEventHandler, useCallback } from 'react';
import { useEscapeKey } from 'src/common/hooks';
import closeIcon from 'src/assets/images/close.png';
import { useStyles } from './Modal.styles';

interface ModalProps {
  title: string;
  isOpen: boolean;
  onClose: VoidFunction;
}

export const Modal: FC<ModalProps> = ({ title, isOpen, onClose, children }) => {
  const styles = useStyles();
  const handleOverlayClick: MouseEventHandler<HTMLDivElement> = useCallback(() => {
    onClose();
  }, [onClose]);
  useEscapeKey(onClose);

  return isOpen ? (
    <div className={styles.modal}>
      <div className={styles.modalTitle}>{title}</div>
      <div className={styles.modalOverlay} onClick={handleOverlayClick} onKeyPress={() => {}} role="presentation" />
      <button type="button" onClick={onClose} className={styles.modalCloseButton}>
        <img className={styles.backIcon} src={closeIcon} alt="close icon" />
      </button>
      <div className={styles.modalBox}>
        <div className={styles.modalContent}>{children}</div>
      </div>
    </div>
  ) : null;
};
